<template>
  <div class="c-tab-data">
    <div class="c-control-btn">
      <Button icon="md-download" @click="downData" :loading="loading">数据导出</Button>
      <Button @click="modalColumn = true" :loading="loading">自定义列</Button>
    </div>
    <div class="tab-data__wrapper">
      <Viewport v-model="tableHeight">
        <el-table
          class="common-el-table-styles"
          :data="tableData"
          :height="tableHeight - 6"
          v-loading="loading"
          border
          ref="tabLogTable"
          style="width: 100%"
        >
          <el-table-column
            v-for="(col, id) in tableCol"
            :key="id + col.key"
            :prop="col.key"
            :label="col.title"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
          >
            <template slot-scope="scope">
              <div class="content-logs" v-if="col.key === 'content_log'">
                <span v-for="(item, id) in scope.row[col.key]" :key="item"
                  >{{ item }}
                  <br v-if="id !== scope.row[col.key].length" />
                </span>
              </div>
              <span v-else>{{ scope.row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>

        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :subTitle="[' ']" @on-select="selectColumn" />
  </div>
</template>
<script>
import moment from 'moment'
import mixinTable from '../../mixin_table'
import columns from '../../../data/log_columns'
import { isArray, timeout } from '@/common/js/utils'
import { getPlanLogInfo } from '@/api/ptom.data.model'
import { HOST_API } from '@/api/config'
import CustomColumn from '@/components/converter/custom-column.vue'

export default {
  name: 'TabLog',
  mixins: [mixinTable],
  components: { CustomColumn },
  props: {
    detailTime: {
      type: Array,
      required: true
    },
    adId: {
      type: String
    },
    creativeIds: {
      type: Array
    },
    adAccountId: {
      type: Number
    },
    mediaId: {
      type: Number
    }
  },
  computed: {
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  methods: {
    buildParams() {
      let date = this.detailTime
      if (!date || date.length !== 2) {
        date = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }

      const [startTime, endTime] = date
      return {
        adId: this.adId,
        creativeIds: this.creativeIds.join(','),
        accountId: this.adAccountId,
        mediaId: this.mediaId,
        pageId: this.pageIndex,
        pageSize: this.pageSize,
        startTime: startTime + ' 00:00:00',
        endTime: endTime + ' 23:59:59'
      }
    },
    downData() {
      const url = `${HOST_API}/api/ptom/planDataDetail/exportLogInfo?`

      const params = this.buildParams()
      const querystring = new URLSearchParams()
      querystring.append('sessionid', this.$store.state.token)

      for (const p in params) {
        querystring.append(p, params[p])
      }
      window.open(url.concat(querystring.toString()))
    },
    getData() {
      const params = this.buildParams()
      params.creativeIds = params.creativeIds.split(',')
      this.loading = true
      getPlanLogInfo(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { log, pageInfo } = data
            if (isArray(log) && pageInfo) {
              const { total_number } = pageInfo
              this.initTableColumns()
              this.tableData = log
              this.total = total_number
            } else {
              this.columns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.columns = []
          this.total = 0
        })
    },
    initTableColumns() {
      const shows = this.getCustomStorage('detailLogCustomColumn') // 同步本地存储自定义列
      if (shows.length) {
        const local_shows = shows
          .filter((ret) => ret)
          .map((ret) => {
            const item = columns.filter((met) => met.key === ret).pop() || {}
            item.show = false
            return item
          })
        const extend_shows = columns
          .filter((ret) => !shows.includes(ret.key))
          .map((ret) => {
            ret.show = true
            return ret
          })
        this.columns = [...local_shows, ...extend_shows]
      } else this.columns = [...columns]
    }
  },
  watch: {
    detailTime() {
      this.pageIndex = 1
      this.getData()
    },
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('detailLogCustomColumn', show)
        timeout(300).then(() => {
          this.$nextTick(() => {
            this.$refs.tabLogTable && this.$refs.tabLogTable.doLayout()
          })
        })
        this.$nextTick(() => {
          this.$refs.tabLogTable && this.$refs.tabLogTable.doLayout()
        })
      },
      deep: true
    }
  },
  data() {
    return {
      tableHeight: 300,
      modalColumn: null,
      tableData: [],
      columns: [],
      sumdata: null
    }
  },
  created() {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-tab-data {
  height: 100%;

  .c-control-btn {
    padding: 5px 0px;
    text-align: right;
  }

  .tab-data__wrapper {
    height: 100%;
    .content-logs {
      line-height: 15px;
    }

    .c-table-page {
      font-size: 12px;
      padding-top: 10px;
      text-align: right;
    }
  }
}
</style>
